import { render, staticRenderFns } from "./error-screen.vue?vue&type=template&id=f31e4bc4&"
import script from "./error-screen.vue?vue&type=script&lang=js&"
export * from "./error-screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports